import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button"];

  connect() {
    this.buttonTarget.classList.add("hidden");
  }

  toggle() {
    this.buttonTarget.classList.toggle("hidden");
  }
}
